var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return false
    ? _c("div", { staticClass: "hl-wid ww4 ubox" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "form",
          {
            staticClass: "user-form",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.saveProfile($event)
              }
            }
          },
          [
            _c("div", { staticClass: "uf-row split4" }, [
              _c("div", [
                _c("div", { staticClass: "uf-row" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userProfile.pubname,
                        expression: "userProfile.pubname"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.userProfile.pubname },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.userProfile,
                          "pubname",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "uf-row" },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("ext-select", {
                      attrs: { options: _vm.levelOpt },
                      model: {
                        value: _vm.userProfile.title,
                        callback: function($$v) {
                          _vm.$set(_vm.userProfile, "title", $$v)
                        },
                        expression: "userProfile.title"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                false
                  ? _c("div", { staticClass: "uf-row" }, [
                      _c("label", [_vm._v("Title")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userProfile.title,
                            expression: "userProfile.title"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.userProfile.title },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userProfile,
                              "title",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "uf-row" }, [
                  _c("label", [_vm._v("About Me")]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userProfile.pubdesc,
                        expression: "userProfile.pubdesc"
                      }
                    ],
                    staticStyle: { height: "150px" },
                    domProps: { value: _vm.userProfile.pubdesc },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.userProfile,
                          "pubdesc",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("label", [_vm._v("Profile Image")]),
                _vm._v(" "),
                _c("div", { staticClass: "pimg-wid" }, [
                  _c("div", { staticClass: "pimg-con" }, [
                    _vm.userProfile.media
                      ? _c("img", {
                          attrs: {
                            src: _vm.photoLinkR(
                              _vm.userProfile.media,
                              256,
                              256,
                              "Fit"
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("a", {
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.selectMedia(null)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pimg-note" }, [
                    _vm._v(
                      "\n            Click on image to edit your public appereance\n          "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "uf-row" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userProfile.location,
                        expression: "userProfile.location"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.userProfile.location },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.userProfile,
                          "location",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "uf-row" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userProfile.languages,
                        expression: "userProfile.languages"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.userProfile.languages },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.userProfile,
                          "languages",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "uf-row" },
                  [
                    _c("label", [_vm._v("My Birthday")]),
                    _vm._v(" "),
                    _c("datepicker", {
                      model: {
                        value: _vm.userProfile.birthday,
                        callback: function($$v) {
                          _vm.$set(_vm.userProfile, "birthday", $$v)
                        },
                        expression: "userProfile.birthday"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "uf-row" }, [
                  _c("label", { staticClass: "check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userProfile.showAge,
                          expression: "userProfile.showAge"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.userProfile.showAge)
                          ? _vm._i(_vm.userProfile.showAge, null) > -1
                          : _vm.userProfile.showAge
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.userProfile.showAge,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.userProfile,
                                  "showAge",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.userProfile,
                                  "showAge",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.userProfile, "showAge", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i"),
                    _vm._v(" "),
                    _c("span", [_vm._v("Show my age on profile")])
                  ])
                ]),
                _vm._v(" "),
                _c("div")
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "uf-row" },
                  [
                    _c("label", [_vm._v("Years of Pilates Experience")]),
                    _vm._v(" "),
                    _c("ext-select", {
                      attrs: { options: _vm.yearsOpt },
                      model: {
                        value: _vm.userProfile.experience,
                        callback: function($$v) {
                          _vm.$set(_vm.userProfile, "experience", $$v)
                        },
                        expression: "userProfile.experience"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "uf-row" }, [
                  _c("label", [_vm._v("Trained By")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userProfile.frequency,
                        expression: "userProfile.frequency"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.userProfile.frequency },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.userProfile,
                          "frequency",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                false
                  ? _c("div", { staticClass: "uf-row" }, [
                      _c("label", { staticClass: "check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userProfile.teacher,
                              expression: "userProfile.teacher"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.userProfile.teacher)
                              ? _vm._i(_vm.userProfile.teacher, null) > -1
                              : _vm.userProfile.teacher
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.userProfile.teacher,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.userProfile,
                                      "teacher",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.userProfile,
                                      "teacher",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.userProfile, "teacher", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i"),
                        _vm._v(" "),
                        _c("span", [_vm._v("I'm a Teacher")])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                false
                  ? _c("div", { staticClass: "uf-row" }, [
                      _c("label", { staticClass: "check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userProfile.owner,
                              expression: "userProfile.owner"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.userProfile.owner)
                              ? _vm._i(_vm.userProfile.owner, null) > -1
                              : _vm.userProfile.owner
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.userProfile.owner,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.userProfile,
                                      "owner",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.userProfile,
                                      "owner",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.userProfile, "owner", $$c)
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i"),
                        _vm._v(" "),
                        _c("span", [_vm._v("I'm a Studio Owner")])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "uf-row" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userProfile.website,
                        expression: "userProfile.website"
                      }
                    ],
                    attrs: { type: "text" },
                    domProps: { value: _vm.userProfile.website },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.userProfile,
                          "website",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "uf-row split4" }, [
              _c("div", [
                _vm._m(6),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userProfile.linkFacebook,
                      expression: "userProfile.linkFacebook"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.userProfile.linkFacebook },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.userProfile,
                        "linkFacebook",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._m(7),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userProfile.linkInstagram,
                      expression: "userProfile.linkInstagram"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.userProfile.linkInstagram },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.userProfile,
                        "linkInstagram",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._m(8),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userProfile.linkTwitter,
                      expression: "userProfile.linkTwitter"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.userProfile.linkTwitter },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.userProfile,
                        "linkTwitter",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._m(9),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userProfile.linkLinkedin,
                      expression: "userProfile.linkLinkedin"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.userProfile.linkLinkedin },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.userProfile,
                        "linkLinkedin",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            false && _vm.userProfile.teacher
              ? _c("h2", [_vm._v("Teacher Details")])
              : _vm._e(),
            _vm._v(" "),
            false && _vm.userProfile.teacher
              ? _c("div", { staticClass: "uf-row split4" }, [
                  _c(
                    "div",
                    { staticClass: "uf-row" },
                    [
                      _vm._m(10),
                      _vm._v(" "),
                      _c("ext-select", {
                        attrs: { options: _vm.levelOpt },
                        model: {
                          value: _vm.userProfile.title,
                          callback: function($$v) {
                            _vm.$set(_vm.userProfile, "title", $$v)
                          },
                          expression: "userProfile.title"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "uf-row" }, [
                    _vm._m(11),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userProfile.teacherName,
                          expression: "userProfile.teacherName"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.userProfile.teacherName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.userProfile,
                            "teacherName",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "uf-row" }, [
                    _vm._m(12),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userProfile.teacherStudio,
                          expression: "userProfile.teacherStudio"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.userProfile.teacherStudio },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.userProfile,
                            "teacherStudio",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "uf-row" },
                    [
                      _vm._m(13),
                      _vm._v(" "),
                      _c("datepicker", {
                        model: {
                          value: _vm.userProfile.teacherDate,
                          callback: function($$v) {
                            _vm.$set(_vm.userProfile, "teacherDate", $$v)
                          },
                          expression: "userProfile.teacherDate"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            false && _vm.userProfile.owner
              ? _c("h2", [_vm._v("Studio Details")])
              : _vm._e(),
            _vm._v(" "),
            false && _vm.userProfile.owner
              ? _c("div", { staticClass: "uf-row split4" }, [
                  _c("div", { staticClass: "uf-row" }, [
                    _c("div", { staticClass: "uf-row" }, [
                      _vm._m(14),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userProfile.studioName,
                            expression: "userProfile.studioName"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.userProfile.studioName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userProfile,
                              "studioName",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "uf-row nomtop" }, [
                      _vm._m(15),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.userProfile.studioWeb,
                            expression: "userProfile.studioWeb"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.userProfile.studioWeb },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.userProfile,
                              "studioWeb",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "uf-row nomtop" }, [
                      _vm._m(16),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "studiop-wid" },
                        [
                          _vm._l(
                            _vm.userProfile.studioLogo
                              ? [_vm.userProfile.studioLogo]
                              : null,
                            function(media) {
                              return _c("div", { staticClass: "studiop-con" }, [
                                media
                                  ? _c("img", {
                                      attrs: {
                                        src: _vm.photoLinkR(
                                          media,
                                          256,
                                          256,
                                          "Fit"
                                        )
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.userProfile.studioLogo = null
                                      }
                                    }
                                  },
                                  [_vm._v("‐")]
                                )
                              ])
                            }
                          ),
                          _vm._v(" "),
                          !_vm.userProfile.studioLogo
                            ? _c("div", { staticClass: "studiop-add" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.selectMedia("studioLogo")
                                      }
                                    }
                                  },
                                  [_vm._v("+")]
                                )
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "uf-row" }, [
                    _vm._m(17),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userProfile.studioAbout,
                          expression: "userProfile.studioAbout"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.userProfile.studioAbout },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.userProfile,
                            "studioAbout",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "uf-row" }, [
                    _vm._m(18),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userProfile.studioLocation,
                          expression: "userProfile.studioLocation"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.userProfile.studioLocation },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.userProfile,
                            "studioLocation",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "uf-row" }, [
                    _vm._m(19),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userProfile.studioEmail,
                          expression: "userProfile.studioEmail"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.userProfile.studioEmail },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.userProfile,
                            "studioEmail",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            false && _vm.userProfile.owner
              ? _c("div", { staticClass: "uf-row split2" }, [
                  _c("div", { staticClass: "blank" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "movedtop" }, [
                    _vm._m(20),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "studiop-wid" },
                      [
                        _vm._l(_vm.studioMedia, function(media, mi) {
                          return _c("div", { staticClass: "studiop-con" }, [
                            media
                              ? _c("img", {
                                  attrs: {
                                    src: _vm.photoLinkR(media, 256, 256, "Fit")
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.removeStudioMedia(mi)
                                  }
                                }
                              },
                              [_vm._v("‐")]
                            )
                          ])
                        }),
                        _vm._v(" "),
                        _vm.studioMedia.length < 4
                          ? _c("div", { staticClass: "studiop-add" }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      _vm.selectMedia(
                                        "studioPhoto" +
                                          (_vm.studioMedia.length + 1)
                                      )
                                    }
                                  }
                                },
                                [_vm._v("+")]
                              )
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "uf-row split4" }, [
              _c("div"),
              _c("div"),
              _vm._v(" "),
              false
                ? _c("div", { staticClass: "uf-row to-c" }, [
                    _c("button", { staticClass: "sec" }, [
                      _vm._v("Profile Preview")
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._m(21)
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ub-head mb" }, [
      _c("h2", [_vm._v("Public Profile")]),
      _vm._v(" "),
      _c("span", { staticClass: "ubh-ico user" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Public Name"), _c("em", [_vm._v("*")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Level"), _c("em", [_vm._v("*")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("My Location"), _c("em", [_vm._v("*")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Spoken languages"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Website"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Your Facebook Account"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Your Instagram Account"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Your Twitter Account"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Your LinkedIn Account"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Level"), _c("em", [_vm._v("*")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Name of Your Teacher"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Your Teacher Studio"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Certification Date"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Studio Name"), _c("em", [_vm._v("*")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Studio Web Address"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Studio Logo"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("About Studio"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Studio Location"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Studio Email"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_vm._v("Studio Photos"), _c("em")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "uf-row to-c" }, [
      _c("button", { staticClass: "main" }, [_vm._v("Update")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }